import React, { useEffect, useState } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Loader from '../components/common/Loader';
import { deleteData, getData, handleError } from '../functions/services';
import DataTable from 'react-data-table-component';
import * as FaIcons from 'react-icons/fa';
import { sweetQuestion } from '../functions/sweetAlert';
import ModalCoach from '../components/modal/ModalCoach';
import { customTableStyles } from '../constants/data';
import empty from '../assets/images/empty.jpeg';
import ModalUpdatePassword from '../components/modal/ModalUpdatePassword';

const Coachs = () => {
    const [openModal, setOpenModal] = useState(false);
    const [openModalPassword, setOpenModalPassword] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [modalData, setModalData] = useState('');

    const onOpenModal = (data) => {
        setModalData(data);
        setOpenModal(true);
    };
    const onCloseModal = () => setOpenModal(false);

    const onOpenModalPassword = (data) => {
        setModalData(data);
        setOpenModalPassword(true);
    };
    const onCloseModalPassword = () => setOpenModalPassword(false);

    const loadTable = async () => {
        try {
            setLoading(true);
            const req = await getData('users/coachs', {});
            setLoading(false);
            setData(req.data);
        } catch (error) {
            console.log(error);
            handleError(error);
        }
    };

    const tableData = () => {
        const columns = [
            {
                name: 'Foto',
                selector: 'photo',
                center: true,
            },
            {
                name: 'Nombre',
                selector: 'name',
                sortable: true,
            },
            {
                name: 'Email',
                selector: 'email',
                sortable: true,
            },
            {
                name: 'Acciones',
                selector: 'actions',
                center: true,
            },
        ];

        let tableArray = [];

        searchArray().forEach((val) => {
            const json = {
                id: val.id,
                photo: (
                    <img
                        src={val.photo ? val.photo : empty}
                        className="table-image py-1"
                        alt="foto de perfil"
                    />
                ),
                name: val.name,
                email: val.email,
                actions: (
                    <>
                        <span
                            className="pointer"
                            onClick={() => onOpenModal(val)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="editar"
                        >
                            <FaIcons.FaPencilAlt className="table-icon" />
                        </span>
                        <span
                            className="pointer"
                            onClick={() => onOpenModalPassword(val)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="actualizar contraseña"
                        >
                            <FaIcons.FaUserLock className="table-icon" />
                        </span>
                        <span
                            className="pointer"
                            onClick={() => onDelete(val.id)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="eliminar"
                        >
                            <FaIcons.FaTrash className="table-icon" />
                        </span>
                    </>
                ),
            };

            tableArray.push(json);
        });

        return (
            <DataTable
                customStyles={customTableStyles}
                noHeader
                pagination
                columns={columns}
                data={tableArray}
            />
        );
    };

    const onDelete = async (id) => {
        const question = await sweetQuestion('Quieres eliminar este coach/mentor?', null);
        if (question.isConfirmed) {
            try {
                await deleteData('users', id);
                loadTable();
            } catch (error) {
                console.log(error);
                handleError(error);
            }
        }
    };

    const searchArray = () => {
        let keys = ['name', 'email'];
        const dataCopy = [...data];

        return dataCopy.filter((value) => {
            return keys.reduce((acum, key) => {
                return acum || value[key].toString().toLowerCase().includes(search.toLowerCase());
            }, false);
        });
    };

    useEffect(() => {
        loadTable();
    }, []);

    return (
        <div>
            <div className="container-page ">
                <div className="page-title">Coachs/Mentores</div>

                <div className="card p-3 mt-3 position-static">
                    <div className="d-flex mb-1">
                        <input
                            type="text"
                            className="form-control page-search mr-auto"
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <button className="btn btn-primary" onClick={() => onOpenModal('')}>
                            Crear Coach/Mentor
                        </button>
                    </div>

                    {loading ? (
                        <div className="center-admin-loader-page">
                            <Loader />
                        </div>
                    ) : (
                        tableData()
                    )}
                </div>
            </div>

            <Modal
                classNames={{ modal: 'modal-size' }}
                open={openModal}
                onClose={onCloseModal}
                center
            >
                <ModalCoach data={modalData} close={onCloseModal} loadTable={loadTable} />
            </Modal>

            <Modal
                classNames={{ modal: 'modal-size' }}
                open={openModalPassword}
                onClose={onCloseModalPassword}
                center
            >
                <ModalUpdatePassword
                    data={modalData}
                    close={onCloseModalPassword}
                    loadTable={loadTable}
                />
            </Modal>
        </div>
    );
};

export default Coachs;
